import React, { useState } from 'react';
import {
  Row,
  Col,
  TabContent,
  TabPane,
  Card,
  CardBody,
  // Button,
  CardHeader,
} from 'reactstrap';
import { useQuery } from '@tanstack/react-query';
import {
  ContactInfo,
  DependentInfo,
  FacilityInfo,
  Documents,
  DelegateApprover,
  ProfileInfo,
} from '../../components/UserProfile';
import { fetchEmployeeDetails } from '../../store/apis/employeeService';
import './Profile.scss';
import { getAuthUser } from '../../utils/auth.util';
import { getCompanyCode } from '../../config/axios.config';
import { iconsChevronLeft } from '../../assets/index';

function Profile() {
  document.title = 'Profile | Envision - Daikin';
  const [activeTab, setActiveTab] = useState('PROFILE');

  const { id, employeeId } = getAuthUser();
  const companyCode = getCompanyCode();

  const payloadBase = {
    userId: id,
    employeeId,
    companyCode,
  };

  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const { data: employeeData, isLoading } = useQuery({
    queryKey: ['employeeDependents', activeTab],
    queryFn: () => fetchEmployeeDetails({ ...payloadBase, type: activeTab }),
  });

  return (
    <div className="page-content">
      <div
        style={{
          borderBottom: '1px solid #EAECF0',
        }}
        className="d-flex flex-row align-items-center gap-3 pb-2 px-3 mb-2 profile-component"
      >
        <button
          type="button"
          className="non-btn"
          onClick={() => window.history.back()}
        >
          <img src={iconsChevronLeft} alt="<<" />
          <span className="back-font-label back">Back</span>
        </button>
        <div
          style={{
            height: '25px',
            borderLeft: '1px solid #EAECF0',
            width: '1px',
          }}
        />
        <span className="profile-heading">Profile</span>
      </div>
      <Row>
        <Col lg={12}>
          <Card className="profile-card-wrapper">
            <CardHeader className="p-0">
              <ul
                className="nav nav-underline profile-component"
                style={{ borderBottom: '1px solid #98A2B3' }}
              >
                <button
                  type="button"
                  onClick={() => toggle('PROFILE')}
                  className={`fw-semibold cursor-pointer nav-link px-3 nav-link ${
                    activeTab === 'PROFILE' ? 'active' : ''
                  }`}
                >
                  My Profile
                </button>
                <button
                  type="button"
                  onClick={() => toggle('CONTACT')}
                  className={`fw-semibold cursor-pointer nav-link px-3 nav-link ${
                    activeTab === 'CONTACT' ? 'active' : ''
                  }`}
                >
                  Contact Details
                </button>
                <button
                  type="button"
                  onClick={() => toggle('DEPENDENTS')}
                  className={`fw-semibold cursor-pointer nav-link px-3 nav-link ${
                    activeTab === 'DEPENDENTS' ? 'active' : ''
                  }`}
                >
                  Dependents
                </button>
                <button
                  type="button"
                  onClick={() => toggle('FACILITY')}
                  className={`fw-semibold cursor-pointer nav-link px-3 nav-link ${
                    activeTab === 'FACILITY' ? 'active' : ''
                  }`}
                >
                  Facility
                </button>
                <button
                  type="button"
                  onClick={() => toggle('DOCUMENTS')}
                  className={`fw-semibold cursor-pointer nav-link px-3 nav-link ${
                    activeTab === 'DOCUMENTS' ? 'active' : ''
                  }`}
                >
                  Documents
                </button>
                <button
                  type="button"
                  onClick={() => toggle('DELEGATE_APPROVER')}
                  className={`fw-semibold cursor-pointer nav-link px-3 nav-link ${
                    activeTab === 'DELEGATE_APPROVER' ? 'active' : ''
                  }`}
                >
                  Delegate Approval
                </button>
              </ul>
            </CardHeader>
            <CardBody className="p-0" style={{ borderRadius: '8px' }}>
              <TabContent activeTab={activeTab} className="h-100">
                <TabPane className="h-100" tabId="PROFILE">
                  <ProfileInfo data={employeeData} isLoading={isLoading} />
                </TabPane>
                <TabPane tabId="CONTACT">
                  <ContactInfo />
                </TabPane>
                <TabPane tabId="DEPENDENTS">
                  <DependentInfo data={employeeData} isLoading={isLoading} />
                </TabPane>
                <TabPane tabId="FACILITY">
                  <FacilityInfo data={employeeData} isLoading={isLoading} />
                </TabPane>
                <TabPane tabId="DOCUMENTS">
                  <Documents data={employeeData} isLoading={isLoading} />
                </TabPane>
                <TabPane tabId="DELEGATE_APPROVER">
                  <DelegateApprover />
                </TabPane>
              </TabContent>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default Profile;
